export const UserTypes = {
    SET_UID: 'SET_UID',
    SET_LOGGED_IN: 'SET_LOGGED_IN'
};